module.exports = __webpack_public_path__ + "static/media/Spoken English.609f0729.webp";